var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.48976 0.51302C6.29533 0.177953 5.81146 0.177951 5.61703 0.513019L4.24778 2.87274C4.15174 3.03826 3.98573 3.15122 3.79651 3.1798L1.23044 3.56737C0.799453 3.63247 0.648274 4.17663 0.983923 4.45471L2.89554 6.03846C3.07249 6.18507 3.15569 6.41631 3.11271 6.64205L2.61266 9.26806C2.53361 9.68319 2.96939 10.0057 3.34331 9.80884L5.75958 8.53657C5.94349 8.43973 6.1633 8.43973 6.34721 8.53657L8.76349 9.80884C9.1374 10.0057 9.57319 9.68319 9.49414 9.26806L8.99409 6.64205C8.95111 6.41631 9.03431 6.18507 9.21126 6.03846L11.1229 4.45471C11.4585 4.17663 11.3073 3.63247 10.8764 3.56737L8.31029 3.1798C8.12106 3.15122 7.95506 3.03826 7.85901 2.87274L6.48976 0.51302Z",
    fill: "#FFB52D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartIcon);
export default __webpack_public_path__ + "static/media/startIcon.04124bcfe6cbc4f5ad7838faa36282f1.svg";
export { ForwardRef as ReactComponent };